import axiosInstanceNew from "../lib/axiosinstanceNew";
const TutorLeaderboard = class {
  constructor() {
    this.baseUrl = "leaderboard/tutors";
    this.staticData = [
      {
        id: 1,
        rank1: {
          first_name: "Rajesh",
          last_name: "Kumar",
        },
        rank2: {
          first_name: "Priya",
          last_name: "Sharma",
        },
        rank3: {
          first_name: "Amit",
          last_name: "Singh",
        },
        month_name: "January 2024",
      },
      {
        id: 2,
        rank1: {
          first_name: "Sunita",
          last_name: "Patel",
        },
        rank2: {
          first_name: "Vikram",
          last_name: "Gupta",
        },
        rank3: {
          first_name: "Meera",
          last_name: "Joshi",
        },
        month_name: "February 2024",
      },
      {
        id: 3,
        rank1: {
          first_name: "Arun",
          last_name: "Verma",
        },
        rank2: {
          first_name: "Kavita",
          last_name: "Mishra",
        },
        rank3: {
          first_name: "Suresh",
          last_name: "Yadav",
        },
        month_name: "March 2024",
      },
      {
        id: 4,
        rank1: {
          first_name: "Anjali",
          last_name: "Agarwal",
        },
        rank2: {
          first_name: "Rohit",
          last_name: "Chauhan",
        },
        rank3: {
          first_name: "Poonam",
          last_name: "Bhatia",
        },
        month_name: "April 2024",
      },
      {
        id: 5,
        rank1: {
          first_name: "Deepak",
          last_name: "Shukla",
        },
        rank2: {
          first_name: "Neha",
          last_name: "Tiwari",
        },
        rank3: {
          first_name: "Manoj",
          last_name: "Pandey",
        },
        month_name: "May 2024",
      },
    ];
  }

  async Getlist() {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: this.staticData,
      };
    } catch (error) {
      console.error("Error fetching tutor leaderboard data:", error);
      throw error;
    }
  }
  async Addlist(data = []) {
    return await axiosInstanceNew.post(`leaderboard/`, data);
  }
};
export default new TutorLeaderboard();
